import { z } from 'zod';
export const MessageSchema = z.object({
    id: z.string(),
    role: z.enum(['user', 'assistant']),
    content: z.string(),
    timestamp: z.number(),
});
export const ChatRequestSchema = z.object({
    message: z.string().min(1),
    threadId: z.string().optional(),
    assistantId: z.string(),
});
export const AuthRequestSchema = z.object({
    credential: z.string().min(1, { message: 'Credential is required' }),
});
export const UserSchema = z.object({
    email: z.string().email(),
    name: z.string(),
    picture: z.string().url().optional(),
    domain: z.string(),
});
export const ChatStreamChunkSchema = z.object({
    type: z.enum(['content', 'done', 'error']),
    content: z.string().optional(),
    messageId: z.string().optional(),
    threadId: z.string().optional(),
    error: z.string().optional(),
});
export const AssistantConfigSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    instructions: z.string(),
});
